import { render } from "./DialogRename.vue?vue&type=template&id=5f9f3db0"
import script from "./DialogRename.vue?vue&type=script&lang=js"
export * from "./DialogRename.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__